import CrudPage from "@/components/CrudPage";
import { useAuth, canWrite } from "@/context/AuthContext";
import { rupiah } from "@/lib/format";
import { Badge } from "@/components/ui/badge";

export default function MasterLabor() {
  const { user } = useAuth();
  const writeRoles = ["akuntansi", "admin_produksi"];
  return (
    <CrudPage
      title="Master Tenaga Kerja"
      subtitle="Operator dan pekerja produksi beserta tarif upah."
      endpoint="/labor-workers"
      canWrite={canWrite(user?.role, writeRoles)}
      searchKeys={["code", "name", "jabatan"]}
      columns={[
        { key: "code", label: "Kode" },
        { key: "name", label: "Nama / Operator" },
        { key: "jabatan", label: "Jabatan" },
        { key: "tarif_per_jam", label: "Tarif/Jam", align: "right", render: (r) => rupiah(r.tarif_per_jam) },
        { key: "tarif_lembur", label: "Tarif Lembur", align: "right", render: (r) => rupiah(r.tarif_lembur) },
        { key: "status", label: "Status", render: (r) => <Badge className={r.status === "aktif" ? "bg-green-100 text-green-800 border-green-200 border" : "bg-slate-100 text-slate-600 border"}>{r.status}</Badge> },
      ]}
      fields={[
        { key: "code", label: "Kode Pekerja" },
        { key: "name", label: "Nama Pekerja / Operator" },
        { key: "jabatan", label: "Jabatan" },
        { key: "tarif_per_jam", label: "Tarif per Jam (Rp)", type: "number" },
        { key: "tarif_lembur", label: "Tarif Lembur (Rp)", type: "number" },
        { key: "status", label: "Status", type: "select", defaultValue: "aktif", options: [{ value: "aktif", label: "Aktif" }, { value: "nonaktif", label: "Nonaktif" }] },
      ]}
    />
  );
}
